require([
  "application"
], function(app) {

  app.filter("hash", function() {
    return function(list, against) {
      return list.filter(function(item) {
        for (var i = 0; i < item.liquortype.length; i++) {
          var type = item.liquortype[i];
          if (against[type]) return true;
        }
        return false;
      });
    };
  });

  app.filter("joiner", function() {
    return function(arr, delimiter) {
      return arr.join(delimiter || " ");
    };
  });

  app.filter("idmaker", function() {
    return function(string) {
      return string.replace(/\s+/g, "");
    };
  });
  
});
define("filters", function(){});

